export default {
  recoTag: {
    id: 'product_thumb_reco_tag',
    defaultMessage: 'Good deal',
  },
  vanishingTag: {
    id: 'product_thumb_vanishing_tag',
    defaultMessage: 'Vanishing deal',
  },
  vanishingStock: {
    id: 'product_thumb_vanishing_stock',
    defaultMessage: 'Only {stock} left!',
  },
  vanishingTimer: {
    id: 'product_thumb_vanishing_timer',
    defaultMessage: 'Ends in: {hours}:{minutes}:{seconds}',
  },
  originalPriceDisplay: {
    id: 'product_thumb_original_price_display',
    defaultMessage: '{price} new',
  },
}
